import React from "react";
import Api from "app/js/api";
import { useUserStore } from "app/js/stores";
import { useHistory, useLocation } from "react-router-dom";

import styles from "./IDPSuccess.scss";

export default function IDPSuccess() {
  const [_user, userActions] = useUserStore();
  const history = useHistory();
  const location = useLocation<{ from: Location } | undefined>();
  const params = new URLSearchParams(location.search);
  const rawNext = params.get("next");

  const next = React.useMemo(() => {
    if (!rawNext) {
      return "/";
    }

    try {
      const target = new URL(rawNext, window.location.origin);

      if (target.origin !== window.location.origin) {
        return "/";
      }

      if (!target.pathname.startsWith("/")) {
        return "/";
      }

      return `${target.pathname}${target.search}${target.hash}`;
    } catch {
      return "/";
    }
  }, [rawNext]);

  React.useEffect(() => {
    async function fetchToken() {
      try {
        const response = await Api.user().getTokenFromSession();
        userActions.setToken(response.data.token);
        history.replace(next);
      } catch (error) {
        history.replace("/");
      }
    }

    fetchToken();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={styles.container}>
      Please, wait a bit. You will be redirected after authentication process
      finish.
    </div>
  );
}
